import React, { useEffect } from 'react';
import { object } from 'prop-types';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import EmbeddedPDF from './EmbeddedPDF';
import { useStatementPdf } from '../../hooks/pdf';
import { fetchStatementPdfPending } from '../../actions/AppActions';

const StatementPdfPage = ({ location }) => {
  const { accountNumber, date } = useParams();
  const dispatch = useDispatch();
  const pdf = useStatementPdf(accountNumber, date);

  useEffect(() => {
    dispatch(fetchStatementPdfPending({ accountNumber, date }));
  }, []);

  return <EmbeddedPDF pdf={pdf} location={location} />;
};

StatementPdfPage.propTypes = {
  location: object,
};

export default StatementPdfPage;
